<template>
    <Card class="resetPWCard md:p-5 w-full md:w-8 lg:w-8">
        <template #title>
            <div class="text-center Paragraph-Medium">
                Enter new password here
            </div>
        </template>
        <template #subtitle>
            <div class="text-center Caption">
                Type unique and strong password here.
            </div>
        </template>
        <template #content>
            <div class="flex flex-column align-items-center gap-3 pt-4 ">
                <label for="username" class="Label align-self-start">New password</label>
                <IconField iconPosition="left" class="w-full">
                    <InputIcon class="pi pi-lock" />
                    <Password v-model="password1" :feedback="false" toggleMask placeholder="Enter new password here" size="small"
                        variant="filled" class="w-full" :invalid="notValid" />
                </IconField>
            </div>
            <div class="flex flex-column align-items-center gap-3 pt-4">
                <label for="username" class="Label align-self-start">Confirm new password</label>
                <IconField iconPosition="left" class="w-full">
                    <InputIcon class="pi pi-lock" />
                    <Password v-model="password2" :feedback="false" toggleMask placeholder="Re-enter new password here" size="small"
                        variant="filled" class="w-full" :invalid="notValid" />
                </IconField>
            </div>
            <div class="flex-column flex align-items-center pt-6">
                <Button label="Reset Password" class="teal-700-button" :disabled="notValid" @click="resetPassword" />
            </div>
        </template>
    </Card>
</template>
<script setup>
import Card from 'primevue/card';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import Password from 'primevue/password';
import Button from 'primevue/button';
import { computed, ref, defineProps, defineEmits } from 'vue';
import * as authApi from "@/api/auth";
import { notifyError, notifySuccess } from '@/utils/notification';

const props = defineProps({
    userEmail: {
        type: String,
        required: true,
    },
});

const password1 = ref("");
const password2 = ref("");

const emit = defineEmits(["to-step-four"]);

const notValid = computed(() => {
    return (password1.value !== password2.value) || password1.value.length < 1 || password2.value.length < 1;
});

const resetPassword = async () => {
    try {
        await authApi.resetPassword({ email: props.userEmail, password: password1.value });
        notifySuccess("Success", "Password has been reset successfully.");
        emit("to-step-four", 4);
    } catch {
        notifyError("Oops!", "Unable to reset password. Please try again.");
    }
};
</script>
<style scoped>
.resetPWCard {
  border: none;
  box-shadow: none;
}
</style>
